export default __webpack_public_path__ + "static/media/success.da097a1d.svg";